<template>
  <div>
    <div class="retrieval-panel">
      <div class="retrieval-composer">
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          :placeholder="retrievalPlaceholder"
          v-model="textarea"
          class="retrieval-textarea"
        ></el-input>
        <div class="retrieval-composer-footer">
          <div
            class="ocr-upload-drop"
            :class="{ 'is-dragover': ocrDragOver }"
            @dragenter="onOcrDragEnter"
            @dragleave="onOcrDragLeave"
            @dragover.prevent="onOcrDragOver"
            @drop.prevent="onOcrDrop"
          >
            <el-tooltip class="item" effect="dark" content="图片识别（支持拖拽）" placement="top">
              <el-upload
                class="retrieval-upload"
                ref="ocrUpload"
                name="img"
                :action="action_url"
                :auto-upload="true"
                list-type="picture"
                accept=".jpg,.png,.gif,.jpeg"
                :file-list="fileList"
                :headers="headers"
                :show-file-list="false"
                :on-success="succesfile"
              >
                <img class="retrieval-upload-icon" src="../../../assets/image/upload.png" alt="图片识别" />
              </el-upload>
            </el-tooltip>
          </div>
          <el-button
            class="retrieval-identify-btn"
            type="primary"
            :loading="loading"
            @click="identifyHandle"
          >
            识别
          </el-button>
        </div>
      </div>
      <div class="notesBox" v-bind:style="{ minHeight: Height + 'px' }">
        <div
          v-if="!identify"
          class="retrieval-spec-wrap"
          v-bind:style="{ minHeight: Height + 'px' }"
        >
          <div class="retrieval-spec">
            <h3 class="retrieval-spec-title">上传规范</h3>
            <ol class="retrieval-spec-list">
              <li>
                建议每次提交需求有明显的标识符，例如：PMID：***** ISBN：******，有明显的标识符，会大大提高识别的准确率
              </li>
              <li>
                如果文献类型是"其他"，请您首先确定"需求内容"的准确性和完整性，如果没有问题，请修改正确的"文献类型"这样也会大大提高识别的准确率
              </li>
              <li>
                图片上传支持 jpg、png、gif、jpeg，注意：请保证图片的清晰度，不然会识别有误
              </li>
              <li>
                如果识别的文章有误或者需要修改识别的信息，请选择"编辑"进行修改，手机端需要在识别以后左滑呼出"编辑"功能
              </li>
              <li>
                注意：1. 如果需要文章的"其他信息"请先点击"识别"，2. 然后请点击"备注"添加其他的信息，其他信息是指：补充材料、正式版等
              </li>
            </ol>
          </div>
        </div>
      <div v-else class="retrieval-result">
        <el-table
          ref="multipleTable"
          class="retrieval-result-table"
          tooltip-effect="dark"
          :row-class-name="tableRowClassName"
          :data="tableData"
          @selection-change="handleSelectionChange"
          @select="selectHandle"
          @select-all="handleSelectAll"
          height="calc(100vh - 580px)"
        >
          <el-table-column type="selection" :selectable="selectable" width="45"></el-table-column>
          <el-table-column label="序号" width="72" type="index"></el-table-column>
          <el-table-column label="提交状态" width="120">
            <template slot-scope="scope">
              <span
                class="retrieval-status"
                :style="{ color: getSubmitStatusDisplay(scope.row.submit).color }"
              >
                {{ getSubmitStatusDisplay(scope.row.submit).text }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="140">
            <template slot="header">
              <span class="retrieval-type-header">文献类型</span>
              <el-popover placement="top" width="220" trigger="hover">
                <p class="retrieval-type-tip">
                  <span>注意：</span>
                  <span class="retrieval-type-tip-warn">
                    若文献类型识别为中文书或英文书，则该文献类型不能进行修改
                  </span>
                </p>
                <i slot="reference" class="el-icon-warning-outline retrieval-type-tip-icon"></i>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <el-dropdown
                trigger="click"
                :disabled="scope.row.disabled"
                @command="(key) => handleTypeCommand(scope.row, key)"
              >
                <span
                  class="retrieval-type-tag"
                  :class="{ 'is-disabled': scope.row.disabled }"
                >
                  {{ scope.row.name }}
                  <i class="el-icon-arrow-down retrieval-type-tag-arrow"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, key) in codeType"
                    :key="key"
                    :command="key"
                    :disabled="scope.row.disabled"
                  >
                    {{ item.text }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column label="需求内容" min-width="220">
            <template slot-scope="scope">
              <div
                v-if="editIndex === scope.$index && editType === 'text'"
                class="retrieval-cell retrieval-cell--edit"
              >
                <el-input
                  v-model="editText"
                  placeholder="请输入需求内容"
                  class="retrieval-cell-input"
                  @blur="blurConfirmHandle"
                ></el-input>
              </div>
              <div v-else class="retrieval-cell">
                <span class="retrieval-cell-text">{{ scope.row.text }}</span>
                <i
                  class="el-icon-edit retrieval-cell-edit-btn"
                  @click="editChange(scope.row, scope.$index, 'text')"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="180">
            <template slot-scope="scope">
              <div
                v-if="editIndex === scope.$index && editType === 'remarks'"
                class="retrieval-cell retrieval-cell--edit"
              >
                <el-input
                  v-model="editText"
                  placeholder="请输入备注内容"
                  class="retrieval-cell-input"
                  @blur="blurConfirmHandle"
                ></el-input>
              </div>
              <div v-else class="retrieval-cell">
                <span
                  class="retrieval-cell-text"
                  :class="{ 'is-placeholder': !scope.row.remarks }"
                >
                  {{ scope.row.remarks || "添加" }}
                </span>
                <i
                  class="el-icon-edit retrieval-cell-edit-btn"
                  @click="editChange(scope.row, scope.$index, 'remarks')"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="88">
            <template slot-scope="scope">
              <button
                type="button"
                class="retrieval-row-edit-btn"
                @click="editHandle(scope.row, scope.$index)"
              >
                编辑
              </button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="tableData.length > 0" class="retrieval-result-footer">
          <button
            type="button"
            class="retrieval-footer-btn retrieval-footer-btn--ghost"
            @click="clearHandle"
          >
            清空结果
          </button>
          <button
            type="button"
            class="retrieval-footer-btn retrieval-footer-btn--outline"
            @click="mergeHandle"
          >
            需求合并
          </button>
          <el-button
            class="retrieval-footer-btn retrieval-footer-btn--primary"
            type="primary"
            :loading="submitLoading"
            @click="submitHandle"
          >
            提交
          </el-button>
        </div>
      </div>
    </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      @close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="需求类型">
          <el-select
            v-model="form.code"
            placeholder="请选择需求类型"
            style="width: 100%"
            :disabled="dialogEditType"
            @change="optionChange"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求内容">
          <el-input v-model="form.text" placeholder="请输入需求内容"></el-input>
        </el-form-item>
        <el-form-item label="添加备注">
          <el-input type="textarea" v-model="form.remarks" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { newSortPost, newDemandPost } from '@/Api/manage'

export default {
  data() {
    return {
      headers: {
        token: localStorage.getItem("token"),
      },
      fileList: [],
      ocrDragOver: false,
      ocrDragCounter: 0,
      textarea: '', // 输入框的值
      Height: 0, // 高度
      identify: false, // 是否识别
      tableData: [], // 识别的表格数据
      submitType: {
        0: { text: '未提交', color: '#909399' },
        1: { text: '提交成功', color: '#409eff' },
        2: { text: '重复提交', color: '#e6a23c' },
        3: { text: '今日非中文书已达上限', color: '#f56c6c' },
        4: { text: '今日中文书已达上限', color: '#f56c6c' },
        5: { text: '提交失败', color: '#f56c6c' },
        6: { text: '需求不能为空', color: '#f56c6c' },
        7: { text: '提交数量已达上限', color: '#f56c6c' },
      },
      codeType: {
        zhBook: { text: '中文书', color: '#d9a673' },
        enBook: { text: '英文书', color: '#d9d973' },
        PMID: { text: 'PMID', color: '#73d9a6' },
        PMC: { text: 'PMC', color: '#73d973' },
        DOI: { text: 'DOI', color: '#8676bd' },
        Url: { text: '链接地址', color: '#73d9d9' },
        zhDoc: { text: '中文文献', color: '#73a6d9' },
        enDoc: { text: '英文文献', color: '#7373d9' },
        patent: { text: '专利', color: '#a673d9' },
        standard: { text: '标准', color: '#d973d9' },
        annex: { text: '附件', color: '#73d8d9' },
        // negative: { text: '紧急消息', color: '#AC2909' },
      },
      multipleSelection: [], // 多选
      editIndex: null, // 编辑行的索引
      editText: '', // 编辑行的文本
      editType: '', // 编辑行的类型
      loading: false, // 加载状态
      options: [
        { value: "zhBook", label: "中文书" },
        { value: "enBook", label: "英文书" },
        { value: "PMID", label: "PMID" },
        { value: "PMC", label: "PMC" },
        { value: "Doi", label: "DOI" },
        { value: "Url", label: "链接地址" },
        { value: "zhDoc", label: "中文文献" },
        { value: "enDoc", label: "英文文献" },
        { value: "patent", label: "专利" },
        { value: "standard", label: "标准" },
      ],
      form: {
        code: '', // 需求类型
        name: '', // 需求类型名称
        text: '', // 需求内容
        remarks: '' // 备注
      },
      dialogVisible: false, // 编辑内容弹窗
      dialogTitle: '', // 编辑弹窗标题
      dialogEditIndex: null, // 编辑行的索引
      dialogEditType: null, // 编辑行的类型
      submitLoading: false, // 提交加载状态
      maxSubmitCount: 10, // 单次最多提交条数
      isMerge: false, // 是否合并
      action_url: process.env.VUE_APP_API_BASE_URL + "literature/ImageOcr/",
      retrievalPlaceholder:
        "请输入识别内容：如DOI:10.31486, toj.20.0025, PMID:34239371, ISBN:9782954099477",
    }
  },
  mounted() {
    this.Height = document.documentElement.clientHeight - 540; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 540;
    }
  },
  methods: {
    // 新的识别需求
    async identifyHandle() {
      if(this.textarea === '') {
        return this.$message.warning('请输入识别内容')
      }
      this.editIndex = null
      this.editText = ''
      this.editType = ''
      this.loading = true
      let res = await newSortPost({ text: this.textarea })
      if(res.data.error_code === 0) {
        this.identify = true
        res.data.data.forEach(item => {
          item.submit = 0
          item.disabled = false
          if(item.code === 'zhBook' || item.code === 'enBook') {
            item.disabled = true
          }
        })
        this.tableData = res.data.data
        this.selectAllSelectableRows()
      } else {
        this.$message.error(res.data.msg)
      }
      this.loading = false
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 多选  批量操作
    handleSelectionChange(val) {
      this.multipleSelection = val.length > this.maxSubmitCount
        ? val.slice(0, this.maxSubmitCount)
        : val
    },
    // 单行勾选，超出上限时阻止
    selectHandle(selection, row) {
      if (selection.length > this.maxSubmitCount) {
        this.$message.warning(`单次最多提交${this.maxSubmitCount}条需求！`)
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(row, false)
        })
      }
    },
    // 表头全选，最多勾选 maxSubmitCount 条
    handleSelectAll(selection) {
      if (!selection.length) {
        return
      }
      const selectableCount = this.tableData.filter((row) => this.selectable(row)).length
      if (selectableCount <= this.maxSubmitCount) {
        return
      }
      this.$message.warning(`单次最多提交${this.maxSubmitCount}条需求！`)
      this.selectAllSelectableRows(this.maxSubmitCount)
    },
    // 判断选中状态
    selectable(row) {
      if (row.submit !== 1 && row.submit !== 2) {
        return true;
      } else {
        return false;
      }
    },
    hasPendingRows() {
      return this.tableData.some((row) => this.selectable(row))
    },
    selectAllSelectableRows(maxCount) {
      const limit = maxCount == null ? this.maxSubmitCount : maxCount
      this.$nextTick(() => {
        const table = this.$refs.multipleTable
        if (!table) {
          return
        }
        table.clearSelection()
        let selectedCount = 0
        this.tableData.forEach((row) => {
          if (selectedCount >= limit) {
            return
          }
          if (this.selectable(row)) {
            table.toggleRowSelection(row, true)
            selectedCount++
          }
        })
      })
    },
    markSubmittedRows(submittedRows, responseData) {
      submittedRows.forEach((row, index) => {
        let submitStatus = 1
        if (responseData) {
          const result = Array.isArray(responseData)
            ? responseData[index]
            : responseData[index]
          if (result) {
            if (result.submit !== undefined) {
              submitStatus = result.submit
            } else if (result.code === 0 || result.error_code === 0) {
              submitStatus = 1
            } else if (result.msg && String(result.msg).indexOf('重复') !== -1) {
              submitStatus = 2
            } else if (result.code !== undefined && result.code !== 0) {
              submitStatus = 5
            }
          }
        }
        row.submit = submitStatus
      })
    },
    syncSelectionAfterSubmit(submittedRows) {
      this.$nextTick(() => {
        const table = this.$refs.multipleTable
        if (!table) {
          return
        }
        submittedRows.forEach((row) => {
          table.toggleRowSelection(row, false)
        })
      })
    },
    // 修改文献类型
    codeChange(index, key, text) {
      this.tableData[index].code = key;
      this.tableData[index].name = text;
    },
    handleTypeCommand(row, key) {
      const item = this.codeType[key];
      if (!item || row.disabled) {
        return;
      }
      this.codeChange(row.index, key, item.text);
    },
    getSubmitStatusDisplay(submit) {
      if (submit === 0) {
        return { text: "未提交", color: "rgba(26, 26, 26, 0.55)" };
      }
      if (submit === 1 || submit === 2) {
        return { text: "已提交", color: "#149041" };
      }
      return (
        this.submitType[submit] || {
          text: "未提交",
          color: "rgba(26, 26, 26, 0.55)",
        }
      );
    },
    // 编辑需求/备注
    editChange(row, index, key) {
      this.editIndex = index;
      this.editType = key;
      this.editText = row[key];
    },
    // 失焦后保存并恢复展示态
    blurConfirmHandle() {
      if (this.editIndex === null) {
        return;
      }
      const index = this.editIndex;
      const type = this.editType;
      const value = (this.editText || "").trim();
      if (type === "text") {
        if (!value) {
          this.editIndex = null;
          this.editType = "";
          this.editText = "";
          return;
        }
        this.tableData[index].text = value;
      } else if (type === "remarks") {
        this.tableData[index].remarks = this.editText || "";
      }
      this.editIndex = null;
      this.editType = "";
      this.editText = "";
    },
    // 批量编辑弹窗
    editHandle(row, index) {
      this.dialogTitle = '编辑需求'
      this.dialogEditIndex = index
      this.dialogEditType = row.disabled
      this.form.code = row.code
      this.form.name = row.name
      this.form.text = row.text
      this.form.remarks = row.remarks
      this.dialogVisible = true
    },
    // 需求类型改变
    optionChange(val) {
      this.form.name = this.codeType[val].text
    },
    // 关闭批量编辑弹窗
    handleClose() {
      this.dialogVisible = false
      this.dialogTitle = ''
      this.form = {
        code: '', // 需求类型
        name: '', // 需求类型名称
        text: '', // 需求内容
        remarks: '' // 备注
      }
    },
    // 确认批量编辑
    handleConfirm() {
      // 合并需求
      if(this.isMerge) {
        let obj = JSON.parse(JSON.stringify(this.form))
        this.multipleSelection.forEach((item, index) => {
          if(index === 0) {
            this.tableData.splice(item.index, 1, {
              code: obj.code,
              name: obj.name,
              text: obj.text,
              remarks: obj.remarks,
              index: item.index,
              submit: 0
            })
          } else {
            this.tableData.splice(item.index, 1)
          }
        })
        this.dialogVisible = false
        this.dialogTitle = ''
        this.isMerge = false
        this.form = {
          code: '', // 需求类型
          name: '', // 需求类型名称
          text: '', // 需求内容
          remarks: '' // 备注
        }
        this.multipleSelection = []
        return
      }
      this.tableData[this.dialogEditIndex].code = this.form.code
      this.tableData[this.dialogEditIndex].name = this.form.name
      this.tableData[this.dialogEditIndex].text = this.form.text
      this.tableData[this.dialogEditIndex].remarks = this.form.remarks
      this.dialogVisible = false
      this.form = {
        code: '', // 需求类型
        name: '', // 需求类型名称
        text: '', // 需求内容
        remarks: '' // 备注
      }
      this.dialogEditIndex = null
    },
    // 清空结果
    clearHandle() {
      this.textarea = ''
      this.tableData = []
      this.identify = false
      this.editIndex = null
      this.editText = ''
      this.editType = ''
      this.multipleSelection = []
    },
    // 提交
    async submitHandle() {
      if(this.multipleSelection.length === 0) {
        return this.$message.warning('请勾选需求任务')
      }
      if(this.multipleSelection.length > this.maxSubmitCount) {
        return this.$message.warning(`单次最多提交${this.maxSubmitCount}条需求！`)
      }
      this.submitLoading = true
      let demandArr = []
      this.multipleSelection.slice(0, this.maxSubmitCount).forEach(item => {
        demandArr.push({
          code: item.code,
          name: item.name,
          text: item.text,
          remarks: item.remarks
        })
      })
      let res = await newDemandPost({
        demand: demandArr
      })
      this.submitLoading = false
      if(res.data.error_code === 0) {
        const submittedRows = [...this.multipleSelection]
        this.markSubmittedRows(submittedRows, res.data.data)
        this.syncSelectionAfterSubmit(submittedRows)
        const shouldClear = !this.hasPendingRows()
        this.$message.success(res.data.msg)
        setTimeout(() => {
          this.$emit('submitHandle', { shouldClear })
        }, 1000)
      } else {
        this.$message.error(res.data.msg)
      }
    },
    // 合并需求
    mergeHandle() {
      if(this.multipleSelection.length < 2) {
        return this.$message.warning('请至少勾选2项需求任务')
      }
      this.isMerge = true
      this.dialogTitle = '合并需求'
      this.multipleSelection.forEach((item, index) => {
        if(index === 0) {
          this.form.text = item.text
          this.form.remarks = item.remarks
          this.form.code = item.code
          this.form.name = item.name
          this.dialogEditType = item.code
        } else {
          this.form.text += item.text
          this.form.remarks += item.remarks
        }
      })
      this.dialogVisible = true
    },
    onOcrDragEnter(e) {
      e.preventDefault();
      this.ocrDragCounter += 1;
      this.ocrDragOver = true;
    },
    onOcrDragLeave(e) {
      e.preventDefault();
      this.ocrDragCounter -= 1;
      if (this.ocrDragCounter <= 0) {
        this.ocrDragCounter = 0;
        this.ocrDragOver = false;
      }
    },
    onOcrDragOver(e) {
      e.preventDefault();
    },
    onOcrDrop(e) {
      this.ocrDragOver = false;
      this.ocrDragCounter = 0;
      const files = Array.from(e.dataTransfer.files || []);
      if (!files.length) return;
      const imageFile = files.find((file) => this.isOcrImageFile(file));
      if (!imageFile) {
        this.$message.warning("请拖拽 jpg、png、gif 格式的图片");
        return;
      }
      const upload = this.$refs.ocrUpload;
      if (!upload) {
        this.$message.error("上传组件未就绪，请稍后重试");
        return;
      }
      upload.handleStart(imageFile);
      const uploadInner = upload.$refs["upload-inner"];
      if (!uploadInner || typeof uploadInner.upload !== "function") {
        this.$message.error("上传组件未就绪，请稍后重试");
        return;
      }
      uploadInner.upload(imageFile);
    },
    isOcrImageFile(file) {
      const acceptTypes = ["image/jpeg", "image/png", "image/gif"];
      if (file.type && acceptTypes.includes(file.type)) {
        return true;
      }
      const ext = (file.name || "").split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif"].includes(ext);
    },
    //ocr 识别回调
    async succesfile(res) {
      if(res.error_code === 0) {
        if(res.data[1].length == 0 || res.data[1] == null) {
          this.$message.error('识别失败，请重新上传')
        } else {
          this.textarea = ''
          res.data[1].forEach(item => {
            this.textarea += item.words + '\n'
          })
          this.identifyHandle()
        }
      } else {
        this.$message.error(res.msg || '识别失败，请重新上传')
      }
    },
  }
}
</script>

<style lang="less" scoped>
.retrieval-panel {
  width: 100%;
  max-width: 1150px;
  margin: 16px auto 0;
  padding: 0;
  box-sizing: border-box;
}

.retrieval-composer {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 940px;
  min-height: 220px;
  margin: 0 auto;
  padding: 16px;
  border: 1px solid #e1e1e2;
  border-radius: 12px;
  background: #fff;
  box-shadow: none;
  box-sizing: border-box;
}

.retrieval-textarea {
  flex: 1 1 auto;
}

.retrieval-composer /deep/ .el-textarea__inner {
  min-height: 168px !important;
  padding: 0;
  border: none;
  resize: none;
  background: transparent;
  box-shadow: none;
  color: #1a1a1a;
  font-size: 14px;
  line-height: 22px;
}

.retrieval-composer /deep/ .el-textarea__inner::placeholder {
  color: rgba(26, 26, 26, 0.36);
}

.retrieval-composer-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 4px;

  .ocr-upload-drop {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 4px;

    &.is-dragover {
      outline: 2px dashed #4c93ff;
      outline-offset: -2px;
      background: rgba(76, 147, 255, 0.04);
    }
  }
}

.retrieval-upload-icon {
  display: block;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.retrieval-identify-btn {
  min-width: 72px;
  height: 36px;
  padding: 0 16px;
  border: none !important;
  border-radius: 8px;
  background: #e2426b !important;
  color: #fff !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

.retrieval-identify-btn:hover,
.retrieval-identify-btn:focus {
  background: #d63a61 !important;
  color: #fff !important;
}

.notesBox {
  margin-top: 32px;
  background-color: transparent;
  padding: 0;
}

.retrieval-spec-wrap {
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 940px;
  margin: 0 auto;
}

.retrieval-spec-title {
  margin: 0 0 12px;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.retrieval-spec-list {
  margin: 0;
  padding-left: 0;
  list-style: none;
  color: rgba(26, 26, 26, 0.55);
  font-size: 14px;
  line-height: 22px;
}

.retrieval-spec-list li {
  position: relative;
  padding-left: 20px;
}

.retrieval-spec-list li::before {
  content: counter(retrieval-spec-counter) ".";
  counter-increment: retrieval-spec-counter;
  position: absolute;
  left: 0;
  top: 0;
  color: rgba(26, 26, 26, 0.55);
}

.retrieval-spec {
  width: 100%;
  counter-reset: retrieval-spec-counter;
}

.retrieval-spec-list li + li {
  margin-top: 8px;
}

.retrieval-result {
  margin-top: 16px;
  width: 100%;
  max-width: 1150px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #e1e1e2;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.retrieval-result-table {
  width: 100%;
}

.retrieval-result-table /deep/ .el-table__header-wrapper th {
  background: #fafafa;
  color: rgba(26, 26, 26, 0.55);
  font-size: 14px;
  font-weight: 500;
  border-bottom: 1px solid #e1e1e2;
}

.retrieval-result-table /deep/ .el-table__header-wrapper th .cell {
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 22px;
}

.retrieval-result-table /deep/ .el-table__body td {
  color: #1a1a1a;
  font-size: 14px;
  border-bottom: 1px solid #f1f2f2;
}

.retrieval-result-table /deep/ .el-table__body tr:last-child td {
  border-bottom: none;
}

.retrieval-result-table /deep/ .el-table::before,
.retrieval-result-table /deep/ .el-table__fixed-right::before,
.retrieval-result-table /deep/ .el-table__fixed::before {
  display: none;
}

.retrieval-result-table /deep/ .el-table-column--selection .cell {
  padding-left: 16px;
}

.retrieval-status {
  font-size: 14px;
  line-height: 22px;
}

.retrieval-type-header {
  margin-right: 4px;
}

.retrieval-type-tip {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: #1a1a1a;
}

.retrieval-type-tip-warn {
  color: #f86b52;
}

.retrieval-type-tip-icon {
  color: rgba(26, 26, 26, 0.45);
  font-size: 14px;
  cursor: pointer;
}

.retrieval-type-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  background: #eef4ff;
  color: #3b82f6;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
  box-sizing: border-box;
}

.retrieval-type-tag.is-disabled {
  cursor: not-allowed;
  opacity: 0.72;
}

.retrieval-type-tag-arrow {
  font-size: 12px;
}

.retrieval-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.retrieval-cell-text {
  flex: 1;
  min-width: 0;
  line-height: 22px;
  word-break: break-all;
}

.retrieval-cell-text.is-placeholder {
  color: rgba(26, 26, 26, 0.36);
}

.retrieval-cell-edit-btn {
  flex-shrink: 0;
  font-size: 14px;
  cursor: pointer;
  color: rgba(26, 26, 26, 0.45);
}

.retrieval-cell-input {
  flex: 1;
  min-width: 0;
}

.retrieval-cell-input /deep/ .el-input__inner {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #e1e1e2;
  border-radius: 6px;
  background: #f4f4f5;
  color: #1a1a1a;
  font-size: 14px;
  line-height: 22px;
  box-shadow: none;
}

.retrieval-row-edit-btn {
  min-width: 52px;
  height: 28px;
  padding: 0 12px;
  border: 1px solid #e1e1e2;
  border-radius: 6px;
  background: #fff;
  color: #262729;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
}

.retrieval-row-edit-btn:hover {
  background: #f8f8f8;
}

.retrieval-result-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid #f1f2f2;
}

.retrieval-footer-btn {
  min-width: 88px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
}

.retrieval-footer-btn--ghost {
  border: 1px solid #e1e1e2;
  background: #fff;
  color: #262729;
}

.retrieval-footer-btn--ghost:hover {
  background: #f8f8f8;
}

.retrieval-footer-btn--outline {
  border: 1px solid #e2426b;
  background: #fff;
  color: #e2426b;
}

.retrieval-footer-btn--outline:hover {
  background: rgba(226, 66, 107, 0.04);
}

.retrieval-footer-btn--primary {
  border: none !important;
  background: #e2426b !important;
  color: #fff !important;
}

.retrieval-footer-btn--primary:hover,
.retrieval-footer-btn--primary:focus {
  background: #d63a61 !important;
  color: #fff !important;
}
</style>